import { query } from '@confluence/query-preloader-tools';

import { DefaultAndSpaceClassificationLevelsQuery } from '../queries/DefaultAndSpaceClassificationQuery.graphql';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = '') {
	return query({
		query: DefaultAndSpaceClassificationLevelsQuery,
		variables: {
			spaceKey,
		},
	});
}
